import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import EventAbstract from './EventAbstract';

/**
 * OnTab
 *
 * Event action handler class.
 */
var OnTab = /*#__PURE__*/function (_EventAbstract) {
  _inherits(OnTab, _EventAbstract);
  var _super = _createSuper(OnTab);
  function OnTab() {
    _classCallCheck(this, OnTab);
    return _super.apply(this, arguments);
  }
  _createClass(OnTab, [{
    key: "exec",
    value:
    /**
     * Execute the action to the event.
     */
    function exec() {
      var shifted = event.shiftKey;
      var node = null;
      var firstItem = this.masterNav.elem.querySelector('a');
      var lastItem = this.masterNav.elem.firstElementChild.lastElementChild.querySelector('li:last-child');

      // If shift key is held.
      if (shifted) {
        node = this.getElement('prev');
        if (this.target === firstItem) {
          this.masterNav.closeAllSubNavs();
          return;
        }
      }
      // No shift key, just regular ol tab.
      else {
        node = this.getElement('next');
        if (this.target.parentNode === lastItem) {
          this.masterNav.closeAllSubNavs();
          return;
        }
      }

      // No nodes were found. Close up behind us.
      if (!node) {
        if (this.item.getDepth() > 1) {
          this.parentNav.closeSubNav();
        }
      }
    }
  }]);
  return OnTab;
}(EventAbstract);
export { OnTab as default };